import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { CernToolbar } from "@authzsvc/common-react-components";
import { keycloakAuthenticated } from "../../selectors";
import MembershipRequestsLink from "./MembershipRequestsLink";
import { logout } from "../../actions/api";
import * as cfg from "../../config";

const HeaderBarGroupsPortal = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const env = process.env.REACT_APP_ENVIRONMENT;

  const authenticated = useSelector((state) => keycloakAuthenticated(state));
  const keycloak = useSelector((state) => state.keycloak.instance);
  const userToken = useSelector((state) => state.keycloak.userToken);

  const menuItems = [
    { key: "membershipRequests", label: <MembershipRequestsLink /> },
    {
      key: "help",
      label: <a href={cfg.sidebar_help}>Help</a>,
    },
  ];

  const selectedKeys = (() => {
    if (location.pathname.startsWith("/requests"))
      return ["membershipRequests"];
    if (location.pathname === "/") return ["home"];
    return [];
  })();

  return (
    <CernToolbar
      extraLogoutFct={() => dispatch(logout())}
      authenticated={authenticated}
      keycloak={keycloak}
      userToken={userToken}
      menuItems={menuItems}
      selectedKeys={selectedKeys}
      environment={env}
    />
  );
};

export default HeaderBarGroupsPortal;
